import React from 'react';
import Banner from '../Banner/Banner';
import Servicecards from '../Servicecards/Servicecards';

const Home = () => {
    return (
        <div>
            <Banner></Banner>
            <Servicecards   ></Servicecards>
            
         

        </div>
    );
};

export default Home;